const Actions = Object.freeze({
  DEAD: 'ima:devtool:dead',
  ALIVE: 'ima:devtool:alive',
  POPUP: 'ima:devtool:popup',
  SETTINGS: 'ima:devtool:settings',
  RELOADING: 'ima:devtool:reloading',
  DETECTING: 'ima:devtool:detecting',
  UNSUPPORTED: 'ima:devtool:unsupported',
  MESSAGE: 'ima:devtool:message'
});
export { Actions };